import * as React from "react"

function CalendarioIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.62 17.48"
      {...props}
    >
      <defs>
        <style>{".cls-5{fill:#fff}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className=".cls-5"
            d="M10.16.83a.85.85 0 00-1.7 0v.84H5.08V.83a.85.85 0 00-1.69 0v.84A3.35 3.35 0 000 5v9.15a3.35 3.35 0 003.39 3.33h5.07a.83.83 0 100-1.66H3.39a1.68 1.68 0 01-1.7-1.67V5a1.68 1.68 0 011.7-1.67v.83a.85.85 0 001.69 0v-.83h3.38v.83a.85.85 0 001.7 0v-.83h3.38v.83a.85.85 0 001.7 0v-.83A1.68 1.68 0 0116.93 5v2.91a.85.85 0 001.69 0V5a3.35 3.35 0 00-3.38-3.33V.83a.85.85 0 00-1.7 0v.84h-3.38z"
          />
          <path
            className=".cls-5"
            d="M4.87 7a.52.52 0 00-.53.52v1.22a.52.52 0 00.53.52h1.27a.52.52 0 00.53-.52V7.49A.52.52 0 006.14 7zM8.68 7a.52.52 0 00-.53.52v1.22a.52.52 0 00.53.52H10a.52.52 0 00.52-.52V7.49A.52.52 0 0010 7zM4.87 10.72a.52.52 0 00-.53.52v1.25a.52.52 0 00.53.52h1.27a.52.52 0 00.53-.52v-1.25a.52.52 0 00-.53-.52zM14.8 12.07a.63.63 0 00-.64-.62.63.63 0 00-.63.62v1.25a.63.63 0 00.63.63h1.23a.63.63 0 100-1.25h-.59z"
          />
          <path
            className=".cls-5"
            d="M14.16 10.82a2.5 2.5 0 102.54 2.5 2.52 2.52 0 00-2.54-2.5m-4.23 2.5a4.23 4.23 0 114.23 4.16 4.19 4.19 0 01-4.23-4.16"
          />
        </g>
      </g>
    </svg>
  )
}

export default CalendarioIcon
